import React from 'react';

const Bundle = ( Component ) => (
	( props ) => (
		<Component { ...props } />
	)
);

import loadNotification from 'bundle-loader?lazy&title=Notification!./components/routes/notification';
import loadNotificationsList from 'bundle-loader?lazy&title=List!./components/routes/notification-list';
import loadTriggers from 'bundle-loader?lazy&title=Triggers!./components/routes/triggers';
import loadTrigger from 'bundle-loader?lazy&title=Trigger!./components/routes/trigger';
import loadObserverSearch from 'bundle-loader?lazy&title=Observer!./components/routes/observer-search';
import loadObserverDetail from 'bundle-loader?lazy&title=Observer!./components/routes/notification-detail';
import loadEmailMedium from 'bundle-loader?lazy&title=Notification!./components/routes/mediums/email';
import loadSlackMedium from 'bundle-loader?lazy&title=Notification!./components/routes/mediums/slack';
import loadDeckMedium from 'bundle-loader?lazy&title=Notification!./components/routes/mediums/deck';
import loadSMSMedium from 'bundle-loader?lazy&title=Notification!./components/routes/mediums/sms';

// TODO: Making default routes to go to Observer search page until we figure out pemissions or move this to studio umbrella.
export const routes = [ {
    title: 'Notification Observer',
    pattern: '/:companyId',
    load: loadObserverSearch
}, {
	title: 'Notification Observer',
	patter: '/',
	load: loadObserverSearch
}, {
	title: 'Notification List',
	pattern: '/:companyId/list',
	load: loadNotificationsList
}, {
    title: 'Notification',
    pattern: '/:companyId/notification/create',
    load: loadNotification
}, {
    title: 'Notification',
    pattern: '/:companyId/notification/edit/:notificationId',
    load: loadNotification
}, {
    title: 'Email Medium',
    pattern: '/:companyId/notification/edit/:notificationId/email/:mediumId',
    load: loadEmailMedium
}, {
    title: 'Slack Medium',
    pattern: '/:companyId/notification/edit/:notificationId/slack/:mediumId',
    load: loadSlackMedium
}, {
	title: 'Deck Medium',
	pattern: '/:companyId/notification/edit/:notificationId/deck/:mediumId',
	load: loadDeckMedium
}, {
	title: 'SMS Medium',
	pattern: '/:companyId/notification/edit/:notificationId/sms/:mediumId',
	load: loadSMSMedium,
}, {
	title: 'Notification Triggers',
	pattern: '/:companyId/triggers',
	load: loadTriggers
}, {
	title: 'Trigger',
	pattern: '/:companyId/triggers/create',
	load: loadTrigger
}, {
	title: 'Trigger',
	pattern: '/:companyId/triggers/edit/:triggerId',
	load: loadTrigger
}, {
	title: 'Notification Observer',
	pattern: '/:companyId/observer',
	load: loadObserverSearch
}, {
	title: 'Notification Details',
	pattern: '/:companyId/observer/:notificationInstanceId/:notificationInstanceDeliveryId/detail',
	load: loadObserverDetail
}  ];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
	const { match } = nextRoute;

	if (
		match &&
		!match.render &&
		typeof match.load === 'function'
	) {
		match.load( ( asyncModule ) => {
			match.render = Bundle(
				asyncModule.default ?
					asyncModule.default
					:
					asyncModule, match.props
			);
			action.ok();
		} );
	} else {
		action.ok();
	}
}
